// extracted by mini-css-extract-plugin
export default {"root":"FloatingInput_root__aiRob"};